// extracted by mini-css-extract-plugin
export var icon = "_ag-3";
export var subtitle = "_ag-2";
export var title = "_ag-1";
export var value = "_ag-0";